
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getRandomRotation() {
  return Math.floor(Math.random() * 60) - 30 // Random rotation between -30 and 30 degrees
}

export function getRandomScale(min = 0.95, max = 1.05) {
  return min + Math.random() * (max - min)
}

